import { simpleSet } from '@r/reducers/utils';

export const excelUrl = simpleSet(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_EXCEL_URL',
  '/Materials.xlsx'
);
